import { render, staticRenderFns } from "./PortalMenu.vue?vue&type=template&id=57ae4972&scoped=true"
import script from "./PortalMenu.vue?vue&type=script&lang=js"
export * from "./PortalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae4972",
  null
  
)

export default component.exports